import SharedActions from './shared.actions'

import * as toastererActions from './toasterer.actions'
import * as fromToasterer from './toasterer.reducer'

import * as userActions from './person.actions'
import * as fromUser from './person.reducer'

import * as bonusPeriodActions from './bonusperiod.actions'
import * as fromBonusPeriod from './bonusperiod.reducer'

export interface SharedState {
  toasterer: fromToasterer.State
  persons: fromUser.State
  bonusPeriods: fromBonusPeriod.State
}

const initialState: SharedState = {
  toasterer: fromToasterer.initialState,
  persons: fromUser.initialState,
  bonusPeriods: fromBonusPeriod.initialState,
}

export const reducer = (state = initialState, action: SharedActions): SharedState => {
  switch (action.type) {
    case toastererActions.ADD_TOAST:
    case toastererActions.REMOVE_TOAST:
      return {
        ...state,
        toasterer: fromToasterer.reducer(state.toasterer, action),
      }

    case userActions.GET_HIERARCHY_ID_TO_CURRENT:
    case userActions.GET_HIERARCHY_ID_TO_CURRENT_SUCCESS:
    case userActions.GET_HIERARCHY_ID_TO_CURRENT_FAILURE:
    case userActions.GET_HIERARCHY_ID_TO_ROOT:
    case userActions.GET_HIERARCHY_ID_TO_ROOT_SUCCESS:
    case userActions.GET_HIERARCHY_ID_TO_ROOT_FAILURE:
      return {
        ...state,
        persons: fromUser.reducer(state.persons, action),
      }

    case bonusPeriodActions.SET_ACTIVE_BONUS_PERIOD:
    case bonusPeriodActions.SET_SELECTED_USER_ACTIVE_BONUS_PERIOD:
      return {
        ...state,
        bonusPeriods: fromBonusPeriod.reducer(state.bonusPeriods, action),
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/store/shared.reducer.ts